import CustomTable from '../../../../../components/table/CustomTable';
import React from 'react';

/**
 *
 * @Author: Cecilia López Martínez
 * @JobTitle : Full Stack Developer - IBL
 * @Email : clopez@ibl.mx
 *
 */
const ActiveRequestsTable = (props) => {
    const {
        pagination,
        tableId,
        searchId,
        thead,
        tbody,
        getActionsButtons,
    } = props;

    return (
        <div className={"mt-3"}>
            <CustomTable
                tableId={tableId}
                searchId={searchId}
                checkbox={false}
                thead={thead}
                tbody={tbody}
                columnActions={true}
                getActionsButtons={getActionsButtons}
                textNotInformation={"no_requests_found"}
            />
            {pagination()}
        </div>
    )

}

export default ActiveRequestsTable
